module.exports = __webpack_public_path__ + "static/media/NO_KIDS.5ceee9ed.svg";